import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const Logo = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 65 43">
      <g fill="currentColor" fillRule="nonzero">
        <path d="M20.2681818 1.98863636L0 41.4909091 25.1431818 6.39090909zM32.5.65909091L0 42.6136364 39.2363636 9.3159091zM50.9068182 24.3840909c-.3416562-.5402348-.3968511-1.2136134-.1477273-1.8022727.1380793-.3293402.3626788-.6151941.65-.8272727l.2068182-.1477273c.285072-.1730438.6119739-.264985.9454545-.2659091.5189921.0114916 1.0104349.2358459 1.3590909.6204545l3.9886364 4.5795455h2.9545455V11.7681818c.0016323-.6013065.3982028-1.1300671.975-1.3.4197521-.1239279.8726468-.0592287 1.2409091.1772727-.6443043-.5313892-1.3604775-.9690506-2.1272728-1.3A18.22955064 18.22955064 0 0058.5 8.2522727c-2.5322171-.92093712-5.2311574-1.29355201-7.9181818-1.09318179h-1.3c-2.2105336.5082648-4.3119858 1.40888719-6.2045455 2.65909089l-.65.4431818-.2659091.1772728-.2068181.1477272L1.35909091 42.6136364 32.5 32.125 65 42.5840909l-14.0931818-18.2z" />
      </g>
    </SvgIcon>
  );
};

export default Logo;
